export default __webpack_public_path__ + "navigation-overview-view-hierarchy-960-c7c06bc2d7da7b3ddbb48d9ed5969a46.webp";